import { toVector3 } from '@utils/conversion/toVector3'
import { Vector3 } from 'three'

type Props<T extends Vector3 = Vector3> = {
  Ea: T
  Sa: T
  Sb: T
  Eb: T
  AThickness: number
  BThickness: number
  AAngle: number
  BAngle: number
}
export default function getPrimeCoordinates({
  Ea,
  Sa,
  Eb,
  Sb,
  AThickness,
  BThickness,
  AAngle,
  BAngle,
}: Props) {
  const EPrimeA = toVector3([
    Ea.x + AThickness * Math.sin(AAngle),
    Ea.z - AThickness * Math.cos(AAngle),
  ])
  const SPrimeA = toVector3([
    Sa.x + AThickness * Math.sin(AAngle),
    Sa.z - AThickness * Math.cos(AAngle),
  ])

  const SPrimeB = toVector3([
    Sb.x + BThickness * Math.sin(BAngle),
    Sb.z - BThickness * Math.cos(BAngle),
  ])
  const EPrimeB = toVector3([
    Eb.x + BThickness * Math.sin(BAngle),
    0,
    Eb.z - BThickness * Math.cos(BAngle),
  ])
  return { EPrimeA, EPrimeB, SPrimeA, SPrimeB }
}
